module.exports = __webpack_public_path__ + "static/media/EULA Agreement.651e9df3.pdf";